import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { IBaseTable, IColumns, IPaginationOptions } from '../util/base-table.util';

@Component({
  selector: 'rpe-base-table',
  templateUrl: './base-table.component.html',
  styleUrls: ['./base-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseTableComponent<T> implements OnInit, OnChanges {

  @ViewChild('paginator') paginator: MatPaginator

  selectAll = false
  initial = false

  @Input() baseTable: IBaseTable<T> = {
    dataSource: [],
    columns: [],
    actions: [],
    paginateOptions: {
      page: 0,
      pageSize: 10,
    }
  }

  @Input() showActions = false
  @Input() actionMenu = false

  @Output() selectedRows: EventEmitter<T[]> = new EventEmitter<T[]>()
  @Output() pageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>()
  @Output() actionClicked = new EventEmitter<T>();

  selection = new SelectionModel<T>(true, [])

  set paginatorOptions(pagination: IPaginationOptions) {
    if (!this.paginator) return

    this.paginator.pageIndex = pagination.page
    this.paginator.pageSize = pagination.pageSize
  }

  public _dataSource: MatTableDataSource<T[]> = new MatTableDataSource<T[]>([]);

  public displayedColumns: string[];

  ngOnInit(): void {
    this.displayedColumns = this.baseTable.columns.map((baseTable: IColumns<T>) => baseTable.caption)

    if (this.baseTable.actions && this.showActions && this.actionMenu) {
      this.displayedColumns.push('actions-menu')
    }

    if (this.baseTable.actions && this.showActions && !this.actionMenu) {
      this.displayedColumns.push('actions')
    }

    this.initial = true
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['baseTable']) {
      this.baseTable.actions = this.baseTable.actions ? this.baseTable.actions : []
      if (this.initial) {
        this.paginatorOptions = {
          page: this.baseTable.paginateOptions?.page ? this.baseTable.paginateOptions?.page : 0,
          pageSize: this.baseTable.paginateOptions?.pageSize ? this.baseTable.paginateOptions?.pageSize : 10
        }
      }
    }
  }

  onPageChangeEvent($event: PageEvent): void {
    this.pageChange.emit($event)
  }
}
